import { GhostIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { AnimatedLoader } from "@/components/Loaders/AnimatedLoader";
import { HotelCard } from "@/features/hotels/components/hotels-list/HotelCard";
import { useHotelFiltersContext } from "@/features/hotels/contexts/HotelFiltersContext";
import { useHotelSortContext } from "@/features/hotels/contexts/HotelSortContext";
import { useHotelSearch } from "@/features/hotels/hooks/useHotelSearch";
import { useHotelSearchResults } from "@/features/hotels/hooks/useHotelSearchResults";
import { useOnHotelOfferClick } from "@/features/hotels/hooks/useOnHotelOfferClick";

export function MayLikeHotelsList() {
  const intl = useIntl();

  const { sortValue } = useHotelSortContext();
  const { filters } = useHotelFiltersContext();
  const { searchResultKey, searchResultToken, progress, isFetching } =
    useHotelSearch();

  const handleOfferClick = useOnHotelOfferClick();

  const {
    data: searchResultData,
    isLoading: isLoadingData,
    isEmpty,
  } = useHotelSearchResults({
    searchResultKey,
    searchResultToken,
    filters,
    shouldFetch: progress === 100,
    sortValue,
  });

  return (
    <>
      {isFetching || isLoadingData ? (
        <>
          <AnimatedLoader icon="buildings" />
          <h3 className="mt-3 font-normal text-text-primary">
            {intl.formatMessage({
              defaultMessage: "Preparing best offers...",
              description: "hotels.preparingBestOffers",
            })}
          </h3>
        </>
      ) : (
        <>
          {isEmpty ? (
            <div className="flex h-full flex-col items-center">
              <div className="mt-[30%] flex flex-col items-center gap-4">
                <GhostIcon size={60} color="#0A22474D" />
                <span className="text-center text-sm text-text-primary">
                  {intl.formatMessage({
                    defaultMessage: "No hotels found",
                    description: "hotels.emptyState",
                  })}
                </span>
              </div>
            </div>
          ) : (
            <div className="w-full px-4">
              <ul className="space-y-2">
                {searchResultData?.pages
                  ?.flatMap((offers) =>
                    offers.data.offers.filter(
                      (offer) => offer.type === "HOTEL",
                    ),
                  )
                  ?.map((hotel) => (
                    <li key={hotel.id}>
                      <HotelCard
                        onClick={() => handleOfferClick(hotel)}
                        hotel={hotel}
                      />
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </>
      )}
    </>
  );
}
